import { createSelector, createSlice } from "@reduxjs/toolkit";
import { chatApi } from "./chat.api";

export interface ChatState {
  conversations: Array<any>;
  currentConversationId: any;
  messages: Record<string, any>;
  conversation?: any;
}

const initialState = {
  conversations: [],
  currentConversationId: undefined,
  conversation: undefined,
  messages: {},
} satisfies ChatState as ChatState;

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setCurrentConversationId(state, action) {
      state.currentConversationId = action.payload.currentConversationId;
      state.conversation = undefined;
    },
    setConversations(state, action) {
      state.conversations = action.payload.converstaions;
    },
    setConversation(state, action) {
      state.conversation = action.payload.conversation;
      state.currentConversationId = undefined;
    },
    addMessage(state, action) {
      state.messages[action.payload.message.conversationId] = [
        ...(state.messages[action.payload.message.conversationId] ?? []),
        action.payload.message,
      ];
    },
    updateConversations(state, action) {
      const conversation = state.conversations.find(
        (conversation) =>
          conversation.conversationId == action.payload.message.conversationId
      );

      if (conversation) {
        state.conversations[state.conversations.indexOf(conversation)] = {
          ...action.payload.message,
          notification:
            action.payload.message.senderId != action.payload.user.id
              ? parseInt(conversation.notification) + 1
              : conversation.notification,
        };
      } else {
        state.conversations = [action.payload.message, ...state.conversations];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      chatApi.endpoints.messages.matchFulfilled,
      (state, action) => {
        const message = action.payload.length > 0 ? action.payload[0] : null;

        if (message) {
          state.messages[message.conversationId] = action.payload;
        }
      }
    );
    builder.addMatcher(
      chatApi.endpoints.managerConversations.matchFulfilled,
      (state, action) => {
        state.conversations = action.payload;
      }
    );
    builder.addMatcher(
      chatApi.endpoints.supportConversations.matchFulfilled,
      (state, action) => {
        state.conversations = action.payload;
      }
    );
  },
});

export const selectConversation = createSelector(
  (state) => state.chat,
  (chat) => chat.conversation
);

export const selectConversations = createSelector(
  (state) => state.chat,
  (chat) => chat.conversations
);

export const selectCurrentConverstaionId = createSelector(
  (state) => state.chat,
  (chat) => chat.currentConversationId
);

export const selectMessages = createSelector(
  (state) => state.chat,
  (chat) => chat.messages
);

export const {
  setConversation,
  setConversations,
  setCurrentConversationId,
  addMessage,
  updateConversations,
} = chatSlice.actions;
